import { useLanguage } from '../i18n/language.js';

/** The authoritative, language-specific pixel-media logo for public surfaces. */
export function LandingWordmark({
  height = 38,
}: {
  readonly height?: number;
}): React.ReactElement {
  const { language } = useLanguage();
  const arabic = language === 'ar';

  return (
    <img
      className="mj-landing-wordmark mj-ltr"
      src={
        arabic ? '/mouja-arabic-pixel-media-logo.svg' : '/mouja-pixel-media-logo.svg'
      }
      alt="Mouja"
      width={Math.round(((arabic ? 858 : 1195) / 316) * height)}
      height={height}
      draggable={false}
      style={{ display: 'block', width: 'auto', height }}
    />
  );
}
